import React from "react";
import Row from 'react-bootstrap/Row';
import Column from 'react-bootstrap/Col';
import LineChartTimelinePolicies from "../../../graphs/LineChartTimelinePolicies";
import BarChartSubquestions from "../../../graphs/BarChartSubQuestions";
import BarChartSubquestionsModelTwo from "../../../graphs/BarChartSubQuestionsModelTwo";
import RegionalLineChartTimelinePolicies from "../../../graphs/RegionalLineChartTimelinePolicies";
import RegionalBarChartSubquestions from "../../../graphs/RegionalBarChartSubQuestions";
import BarChartOrganisationsPerRegion from "../../../graphs/BarChartOrganisationsPerRegion";

  

  const PoliciesResponsesSubSection = (props) => {
    console.log(props.size);
    return (
     <>
      {props.type === "regional" ? 
      <>
    {props.dataRegionalTimeline.length > 0 &&  
    <Row>
  <RegionalLineChartTimelinePolicies
     isSubquestion={false}
       size={props.size}
    data={props.dataRegionalTimeline}
    graphTitle={props.graphTitle[0]}
     />
</Row>}
{props.dataRegionalDetails.length > 0 &&
<Row>
  {props.graphTitle[1] !== "graphB43_title2" &&
   < RegionalBarChartSubquestions 
     isSubquestion={false}
       size={props.size}
   data={props.dataRegionalDetails} 
   subQuestionLabels={props.subquestionsLabels} 
   graphTitle={props.graphTitle[1]}/>}
    {props.graphTitle[1] === "graphB43_title2" &&
    <div><BarChartOrganisationsPerRegion 
    isSubquestion={false}
       size={props.size}
   data={props.dataRegionalDetails} 
   subQuestionLabels={props.subquestionsLabels} 
   graphTitle={props.graphTitle[1]}
    /></div>}
</Row>}
</> :
      props.isOneRow ?
 <Row>
  {props.dataGlobalTimeline.length > 0 &&
<Column>
    <LineChartTimelinePolicies
     isSubquestion={true}
    data={props.dataGlobalTimeline}
    graphTitle={props.graphTitle[0]} 
   />
    </Column>}

{props.dataGlobalDetails.length > 0 &&
<Column>
    <BarChartSubquestions 
     isSubquestion={true}
    isOneRow={props.isOneRow}
    data={props.dataGlobalDetails}
          titleY='graphA11_ybar_label1'

    graphTitle={props.graphTitle[1]} 
   label={props.subquestionsLabels} />  </Column>}
  
</Row>: <>
{props.dataGlobalTimeline.length > 0 &&
<Row>
      <LineChartTimelinePolicies
     isSubquestion={false}
    data={props.dataGlobalTimeline}
    graphTitle={props.graphTitle[0]} 
   />
    </Row>}
   {props.dataGlobalDetails.length > 0  && 
   <Row>
     <BarChartSubquestions 
     isSubquestion={true}
    isOneRow={props.isOneRow}
          titleY='graphA11_ybar_label1'

    data={props.dataGlobalDetails}
    graphTitle={props.graphTitle[1]} 
   label={props.subquestionsLabels} />
     {/* <BarChartSubquestionsModelTwo 
     isSubquestion={false}
     size={props.size}
     mobileLabels={props.mobileLabels}
     isMobile={props.isMobile}
    data={props.dataGlobalDetails}
    graphTitle={props.graphTitle[1]} 
   label={props.subquestionsLabels} /> */}
   </Row>}
</> 
 
}



     </>
    );
  };
  
  export default PoliciesResponsesSubSection;
  
